import { useContext } from 'react';
import {
  HomeIcon,
  PlusIcon,
  PuzzleIcon,
  UsersIcon,
} from '@heroicons/react/outline';
import getModalContext from '../../context/getModalContext';
import { Link } from 'react-router-dom';
import paths from '../../constants/routes.json';

export default function EmptyGrid() {
  const modals = useContext(getModalContext());

  return (
    <div className="pt-7 text-center">
      <UsersIcon className="mx-auto h-12 w-12 text-gray-400 stroke-1" />
      <h3 className="mt-2 text-sm font-medium text-gray-900">No contacts</h3>
      <p className="mt-1 text-sm text-gray-500">
        Get started by creating a contact.
      </p>
      <div className="mt-6">
        <Link
          to={`${paths.PEOPLE}/new`}
          type="button"
          className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
        >
          <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
          Add New Contact
        </Link>
      </div>
    </div>
  );
}
